module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/next_on-af6bb9fa3febaa6e490f7958dfc156d3.gif";